import PosthogService from '~/services/posthog/PosthogService';

// Event-specific interface (co-located)
export interface IPermPostJobTermsAddendumSubmittedPayload {
  postingId: string;
}

/**
 * Fires when user accepts and submits the terms and conditions addendum
 * Event: dental_portal:perm_post_job:terms_addendum_submitted
 */
export function firePermPostJobTermsAddendumSubmitted(
  payload: IPermPostJobTermsAddendumSubmittedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:perm_post_job:terms_addendum_submitted', {
    posting_id: payload.postingId,
  });
}